import { Setup } from "ruffle-core";

Setup.installRuffle("local");
